import React from 'react'
import WeekFilterAccess from './WeekFilterAccess'
import getFilterStrings from '../functions/getFilterStrings'
import SecondaryFilterAccess from './SecondaryFilterAccess'


const OverviewFilterAccess = ({
    queryStringValues,
    filters,
    dayFilters,
    allItems,
    cinemaFrontPkType
}) => {
    const filterStrings = getFilterStrings(queryStringValues)

    return (
        <div className="overview-filter">
            <WeekFilterAccess
                queryStringValues={queryStringValues}
                filterStrings={filterStrings}
                dayFilters={dayFilters}
            />

            <SecondaryFilterAccess
                filters={filters}
                filterStrings={filterStrings}
                allItems={allItems}
                queryStringValues={queryStringValues}
                cinemaFrontPkType={cinemaFrontPkType}
            />
        </div>
    )
}

export default OverviewFilterAccess